import { useBusinessOrganizationPricingConfig } from '@sales-portal/blocs/hooks/use-business-organization-pricing-config';
import { useGeneratedGetPricingHubCostChangesQuery } from '@sales-portal/domain/pricing/screens/overview/blocs/documents/pricing-hub-cost-changes.generated';
import { useMemo } from 'react';

export const usePricingHubCostChangesLoader = () => {
  const { hasPricingAccess } = useBusinessOrganizationPricingConfig();

  const { data, error, loading } = useGeneratedGetPricingHubCostChangesQuery({
    fetchPolicy: 'cache-and-network',
    skip: !hasPricingAccess,
  });

  return useMemo(
    () => ({
      costChanges: data?.getPricingHubCostChanges,
      error,
      isLoading: loading && !data,
    }),
    [data, error, loading],
  );
};
